module.exports = __webpack_public_path__ + "img/12.a6ac0280.png";